module.exports = __webpack_public_path__ + "img/missionManage.26193936.png";